import React, { ReactElement } from 'react';
import styled from 'styled-components';

const StyledFooter = styled.footer`
  width: 100%;
  padding: 0.5em 0;
  position: fixed;
  background-color: lavender;
  bottom: 0;
  left: 0;
  overflow: hidden;
  text-align: center;
`;

const Footer = (): ReactElement => (
  <StyledFooter>
    Jonathan Christopher Jakub • Josh Sudung Pangihutan | FunPro CS UI 2020
  </StyledFooter>
);

export default Footer;
